import APIUtils from '@spothero/utils/api';

const OversizedFeeAPI = {
    getOversizedFee({facilityId, make, model, year}) {
        return APIUtils.get('oversized-fee/', {
            facility_id: facilityId, // eslint-disable-line camelcase
            make,
            model,
            year
        });
    }
};

export default OversizedFeeAPI;
